import React, {useState} from "react";
import {useSelector} from "react-redux";
import Toast from "cogo-toast";
import {apiDeleteUser} from "./Actions";
import ETable, {DeleteIconBtn, EditIconBtn} from "../components/Table";
import {fmtDateTime} from "../../../functions/formatDate";

const COMPETENCY_LABEL = {admin: "Administrátor", user: "Běžný uživatel"};

const AccessUserTable = ({data, setData}) => {
    const [deletingId, setDeletingId] = useState(null);
    const user = useSelector((state) => state.user);

    const handleDelete = (id) => {
        if (!window.confirm("Opravdu chcete smazat tohoto uživatele?")) return;
        setDeletingId(id);
        apiDeleteUser(user.activeAreal.id, id, () => {
            setData(prev => prev.filter(u => u.id !== id));
            setDeletingId(null);
            Toast.success("Uživatel byl smazán.");
        }, () => {
            setDeletingId(null);
            Toast.error("Nepodařilo se smazat uživatele.");
        });
    };

    const columns = [
        {header: "ID",            key: "id"},
        {header: "Jméno",         key: "name"},
        {header: "E-mail",        key: "email"},
        {header: "Právo",         render: row => COMPETENCY_LABEL[row.competency] ?? "-"},
        {header: "Vytvořen",      render: row => fmtDateTime(row.createdAt)},
        {header: "Poslední akce", render: row => fmtDateTime(row.lastAction)},
        {header: "Možnosti", render: row => (
            <div style={{display: "flex", gap: "6px", alignItems: "center"}}>
                <EditIconBtn to={"/access/user/detail/" + row.id}/>
                {user?.user?.rights?.enigooTurniketsEdit && (
                    <DeleteIconBtn onClick={() => handleDelete(row.id)} disabled={deletingId === row.id}/>
                )}
            </div>
        )},
    ];

    return <ETable columns={columns} data={data}/>;
};

export default AccessUserTable;
